/**
 * Global Variables
 */
let $shopMap
let $shopBrand = $('[data-js-name="search__filter__brand"]')
let $shopList = $('[data-js="search-list__shops"]')
let $resultCase = $('[data-js-name="search__filter__total"]')
let $btnNearMe = $('[data-js-name="search__filter__store-near-me"]')
let $btnClear = $('[data-js-name="search__clear"]')
let $inputKeyword = $('[data-js-name="search__filter__keyword"]')
let $listWrapper = $('[data-js="search-list__cities"]')
let $searchSelectOption = $('[data-js-name="search__filter__option"]')
let $notFound = $('[data-js="search-list__not-found"]')
let $notFoundOverlay = $('[data-js="search-list__not-found__overlay"]')
let $notFoundClose = $('[data-js="search-list__not-found__close"]')
let $notFoundList = $('[data-js="search-list__shop__not-found"]')
let $shopListTemplate = $('[data-js="search-list__template"]')
let $searchSubmit = $('[data-js-name="search__filter__submit"]')
let $searchForm = $('#stores_search__form')

/**
 * Global Map Config
 */
let shopMasterBrandKey = 'brand'
let shopMasterBrandTotal = 14
let latitudeDefault = 35.6636038
let longitudeDefault = 139.7140387
let zoomDefault = 6
let globalZoom = 2
let limitNearestStore = 10
let timeout = 200
let isAllowGetCurrentPosition = true
let isSearchNearMe = false
let markers = []
let markerCluster
let balloon
let currentShopList = []

/**
 * Global Marker Clustering Config
 */
const DEFAULT_CLUSTER_OPTION = {
  styles: [
    {
      url: getAssetByName('icon_pin.svg'),
      height: 42,
      width: 30,
      textColor: '#fff'
    },
    {
      url: getAssetByName('icon_pin.svg'),
      height: 60,
      width: 44,
      textColor: '#fff'
    },
    {
      url: getAssetByName('icon_pin.svg'),
      height: 60,
      width: 44,
      textColor: '#fff'
    }
  ],
  maxZoom: 16,
}

/**
 * Default Marker Clustering Styles
 */
DEFAULT_CLUSTER_OPTION.styles = DEFAULT_CLUSTER_OPTION.styles.concat(
  [
    {
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.attraction",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "gamma": "1.00"
        },
        {
          "visibility": "on"
        },
        {
          "saturation": "100"
        },
        {
          "hue": "#0053ff"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "transit.station.bus",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "transit.station.rail",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "transit.station.rail",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "weight": 0.5
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#b4d4e1"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "color": "#c4e3ec"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#e9e9e9"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#cfcece"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ]
)

/**
 * @param fileName
 */
function getAssetByName (fileName) {
  if (shopListAsset) {
    return shopListAsset.replace('FILE', fileName)
  }
}

/**
 * @returns {boolean}
 */
function isSearchNow () {
  const searchHistoryArray = getSearchHistory()

  return searchHistoryArray && searchHistoryArray[0] !== ''
}

/**
 * @param successCallback
 * @param failCallback
 */
function getCurrentLocation (successCallback, failCallback) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(successCallback, function () {
      failCallback()

      if (!isSearchNow()) {
        alert('現在地を取得できませんでした。')
      }
    }, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    })
  } else {
    alert('現在地を取得できませんでした。')
  }
}

/**
 * @param fromMarker
 * @param target
 */
function getDistanceBetween (fromMarker, target) {
  const newLatLng = new google.maps.LatLng(target.latitude, target.longitude)

  return google.maps.geometry.spherical.computeDistanceBetween(fromMarker.position, newLatLng)
}

/**
 * @param fromMarkers
 * @param target
 * @param limit
 */
function getClosestMarkers (fromMarkers, target, limit) {
  const markersDistances = []

  for (let num = 0; num < fromMarkers.length; num++) {
    markersDistances[num] = {
      distance: getDistanceBetween(fromMarkers[num], target),
      marker: fromMarkers[num]
    }
  }

  const closestMarkers = _.sortBy(markersDistances, function (markerDistance) {
    return markerDistance.distance
  }).slice(0, limit)

  return _.map(closestMarkers, function (item) {
    return item.marker
  })
}

/**
 * @param stores
 */
function handleUpdateMap (stores) {
  if (markerCluster instanceof MarkerClusterer) {
    markerCluster.clearMarkers()
  }

  markerCluster = new MarkerClusterer($shopMap, stores, DEFAULT_CLUSTER_OPTION)
}

/**
 * Set Google Map Zoom
 */
function setMapZoomDefault (isClear = false) {
  try {
    setTimeout(function () {
      if (isClear) {
        setMainZoom()
      } else {
        if ($shopMap.getZoom() > 16) $shopMap.setZoom(16)
        if (isAllowGetCurrentPosition) {
          $shopMap.setZoom($shopMap.getZoom() - 1)
        }
      }
    }, timeout)
  } catch (e) {
    $shopMap.setZoom(zoomDefault)
  }
}

/**
 * @param latitude
 * @param longitude
 */
function setMapCenter (latitude, longitude) {
  setTimeout(function () {
    $shopMap.setCenter(
      new google.maps.LatLng(
        parseFloat(latitude),
        parseFloat(longitude)
      )
    )
  }, timeout)
}

/**
 * update History from Url
 */
function updateHistory () {
  let params = []
  let $searchSelectOptionValue = $searchSelectOption.val()
  let $shopBrandValue = $shopBrand.val()
  let $inputKeywordValue = $inputKeyword.val()

  if ($searchSelectOptionValue.trim() !== '') {
    params.push("type=" + $searchSelectOptionValue)
  } else {
    params.push("type=")
  }

  if ($shopBrandValue.trim() !== '') {
    params.push("brand=" + $shopBrandValue)
  } else {
    params.push("brand=")
  }

  if ($inputKeywordValue.trim() !== '') {
    params.push("keyword=" + $inputKeywordValue)
  } else {
    params.push("keyword=")
  }

  if (params.length) {
    
    history.replaceState('', '', "?" + params.join("&")+window.location.hash)
  }
}

/**
 * show not found
 */
function showNotFoundPopup () {
  $notFoundList.show()
  $notFound.show()
  $notFoundOverlay.show()
}

/**
 * hide not found
 */
function hideNotFoundPopup (isPopup) {
  if (!isPopup) {
    $notFoundList.hide()
  }

  $notFound.hide()
  $notFoundOverlay.hide()
}

/**
 * set main zoom
 */
function setMainZoom () {
  setTimeout(function () {
    $shopMap.setZoom(globalZoom)
  }, timeout)
}

/**
 * @param data
 * @returns array
 */
function sortMarker(data) {
  return _.sortBy(data, function (item) {
    return parseInt(item.position) || 0
  })
}

/**
 * @param isSearch
 * @param markerFilter
 */
function handleSearchMap (isSearch, markerFilter) {
  if (isSearch) {
    let markerFilterSort = sortMarker(markerFilter)

    setShopList(markerFilterSort)
    handleUpdateMap(markerFilterSort)

    if (markerFilterSort.length) {
      hideNotFoundPopup()
      setMainZoom()
      setMapCenter(markerFilterSort[0].data.latitude, markerFilterSort[0].data.longitude)
    } else {
      showNotFoundPopup()
      setMapZoomDefault(true)
      setMapCenter(latitudeDefault, longitudeDefault)
    }
  } else {
    setShopList(markers)
    handleUpdateMap(markers)
    setMapZoomDefault(true)
    setMapCenter(latitudeDefault, longitudeDefault)
  }
}

/**
 * @param markers
 */
function setFitBound (markers) {
  let bounds = new google.maps.LatLngBounds()

  if (markers.length) {
    markers.forEach(function (marker) {
      bounds.extend(marker.position)
    })
  }

  setTimeout(function () {
    $shopMap.fitBounds(bounds)
  }, timeout)
}

/**
 * @param markerFilterResult
 */
function getSearchResults (markerFilterResult) {
  let isSearch = false
  let $searchSelectOptionValue = $searchSelectOption.val()
  let $shopBrandValue = $shopBrand.val()
  let $inputKeywordValue = $inputKeyword.val()

  // Search Type
  if ($searchSelectOptionValue !== '') {
    isSearch = true
    markerFilterResult = markerFilterResult.filter(function (marker) {
      return marker.data[$searchSelectOptionValue] == true
    })
  }

  // Search Brand
  if ($shopBrandValue !== '') {
    isSearch = true
    let value = $shopBrand.find(':selected').text()
    console.log(value)
    markerFilterResult = markerFilterResult.filter(function (marker) {
      for (let num = 1; num <= shopMasterBrandTotal; num++) {
        if (marker.data[shopMasterBrandKey + num] === value) {
          return true
        }
      }
      return false
    })
  }

  // Search Keyword
  if ($inputKeywordValue !== '') {
    isSearch = true

    let searchString = $inputKeywordValue.toLowerCase().trim()
    let values = searchString.split(/ |　/).filter(text => text)

    if (values.length) {
      markerFilterResult = markerFilterResult.filter(function (marker) {
        let result = false

        values.forEach(function (value) {
          if (marker.data['address'].toLowerCase().includes(value)
            || marker.data['keyword'].toLowerCase().includes(value)) {
            result = true
          }
        })

        return result
      })
    }
  }

  return {
    data: markerFilterResult,
    isSearch
  }
}

/**
 * Set Markers Visible
 */
function setShopVisible () {
  let isSearch = false
  let markerFilter = markers || []

  if (markerFilter.length) {

    // Search NearMe
    if (isSearchNearMe) {
      getCurrentLocation(function (position) {
        let closestMarkers = getClosestMarkers(markers, position.coords, limitNearestStore)
        markerFilter = getSearchResults(closestMarkers).data

        if (isSearchNow()) {
          setFitBound(markerFilter)
        } else {
          setTimeout(function () {
            $shopMap.fitBounds(new google.maps.LatLngBounds())
            $shopMap.setZoom(5)
          }, timeout)
        }

        if (markerFilter.length) {
          hideNotFoundPopup()
        } else {
          showNotFoundPopup()
          setMapCenter(latitudeDefault, longitudeDefault)
        }

        setShopList(markerFilter)
        handleUpdateMap(markerFilter)

        if (!isSearchNow() && position.coords) {
          setMapCenter(position.coords.latitude, position.coords.longitude)
        }
      }, function () {
        isAllowGetCurrentPosition = false
        isSearchNearMe = false

        let searchResult = getSearchResults(markers)
        markerFilter = searchResult.data
        isSearch = searchResult.isSearch

        handleSearchMap(isSearch, markerFilter)
        setFitBound(markerFilter)
      })
    } else {
      let searchResult = getSearchResults(markers)
      markerFilter = searchResult.data
      isSearch = searchResult.isSearch

      handleSearchMap(isSearch, markerFilter)
      setFitBound(markerFilter)
    }
  } else {
    showNotFoundPopup()
    setMapCenter(latitudeDefault, longitudeDefault)
  }
}

/**
 * Update Map By Filter
 */
function updateMapFilter () {
  setShopVisible()
  updateHistory()
}

/**
 * Clear Form
 */
function clearSearchForm () {
  $searchSelectOption.val('')
  $shopBrand.val('')
  $inputKeyword.val('')
  history.replaceState(null, null, window.location.pathname)
  isSearchNearMe = false
}

/**
 * Near Me Event Click
 */
$btnNearMe.on('click', function () {
  isSearchNearMe = true
  setShopVisible()
})

/**
 * Clear Search Event Click
 */
$btnClear.on('click', function () {
  setMapZoomDefault(true)
  setShopList(markers)
  handleUpdateMap(markers)
  setMapCenter(latitudeDefault, longitudeDefault)
  setFitBound(markers)
  clearSearchForm()
  hideNotFoundPopup()
  updateHistory()
})

/**
 * Page Event Click
 */
$searchForm.on('submit', function (e) {
  e.preventDefault()
  updateMapFilter()
})

$searchSubmit.on('click', function () {
  updateMapFilter()
})

$notFoundClose.on('click', function () {
  hideNotFoundPopup(true)
})

$searchSelectOption.on('change', function () {
  //updateMapFilter()
})

$shopBrand.on('change', function () {
  //updateMapFilter()
})

$inputKeyword.on('change', function () {
  isSearchNearMe = false
  //updateMapFilter()
})

/**
 * @returns {string[]}
 */
function getSearchHistory () {
  return location.search.replace(/^\?/, '').split('&')
}

/**
 * Fill history
 */
function initSearchHistory () {
  if (location.search) {
    _.each(getSearchHistory(), function (param) {
      const value = param.split('=')

      switch (value[0]) {
        case "type":
          $searchSelectOption.val(value[1])
          break
        case "brand":
          $shopBrand.val(value[1])
          break
        case "keyword":
          $inputKeyword.val(decodeURIComponent(value[1]))
          break
      }
    })
  }
}

/**
 * Init Map for Google Map API
 */
function initMap () {
  setMapMarker()
}

window.initMap = initMap

/**
 * @param dataMarkers
 * @param isSetCurrent
 */
function setShopList (dataMarkers, isSetCurrent = true) {
  if (isSetCurrent) {
    currentShopList = dataMarkers
  }

  const shopTemplate = _.template($shopListTemplate.html())
  $shopList.html('')

  dataMarkers.forEach(function (shop) {
    $shopList.append(shopTemplate(shop.data))
  })

  // set Result
  $resultCase.text(dataMarkers.length || 0)

  // scroll Top
  $listWrapper.scrollTop(0)
}

/**
 * Set Google Map Markers
 */
function setStoreMarkers () {
  let shopMasterObjectDataSort = shopMasterObjectData

  shopMasterObjectDataSort.forEach(function (shop) {
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(parseFloat(shop.latitude), parseFloat(shop.longitude)),
      map: $shopMap,
      icon: {
        url: getAssetByName('icon_pin.svg'),
        size: new google.maps.Size(24, 30),
      },
    })

    marker.data = _.omit(shop, 'marker')
    marker.addListener("click", shopOnClick)
    markers.push(marker)
  })
}

/**
 * Filter Store Brands
 */
function setStoreBrands () {
  const brands = []

  if (shopMasterObjectData.length) {
    shopMasterObjectData.forEach(function (shop) {
      for (let num = 1; num <= shopMasterBrandTotal; num++) {
        let brandName = shop[shopMasterBrandKey + num]

        if (brandName !== '') {
          brands.push(brandName)
        }
      }
    })
  }
}

/**
 * Store Marker Cluster
 */
function setMarkerCluster () {
  markerCluster = new MarkerClusterer($shopMap, markers, DEFAULT_CLUSTER_OPTION)
  console.log(markerCluster)
}

/**
 * MapMarker for Google Map API
 */
function setMapMarker () {
  try {
    setMap()

    if (shopMasterObjectData.length) {
      const searchHistoryArray = getSearchHistory()

      setStoreMarkers()
      setStoreBrands()
      setMarkerCluster()

      if (searchHistoryArray && searchHistoryArray[0] !== '') {
        initSearchHistory()
        updateMapFilter()
      } else {
        // isSearchNearMe = true
        setShopVisible()
      }
    }

    $shopMap.addListener("zoom_changed", () => {
      if (balloon) {
        balloon.close()

        $('[data-js="search-list__shops__item"]').removeClass('active')
        resetShopList()
        balloon = null
      }
    })

    /*$(document).on("click", ".p-stores-search-map__sidebar__headline", function () {
      const shop_code = $(this).attr('data-shop_code');
      const foundElement = currentShopList.find(el => el.data.shop_code == shop_code)
      const elementItem = $('[data-js="search-list__shops__item"]')
      const elementItemParent = $(this).closest('[data-js="search-list__shops__item"]')

      setTimeout(function () {
        $shopMap.setZoom(19)

        // set Class
        elementItem.removeClass('active')
        elementItemParent.addClass('active')

        // set Event
        this.data = foundElement.data
        shopOnClick(foundElement, true)
      }, 100)
    })*/
  } catch (e) {
    google.maps.event.addListener(window, 'load', setMap)
  }

  /**
   * set map for Google Map API
   */
  function setMap () {
    $shopMap = new google.maps.Map(document.querySelector('[data-js="stores-map"]'), {
      zoom: globalZoom,
      maxZoom: 18 ,
      disableDoubleClickZoom: true,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      styles: DEFAULT_CLUSTER_OPTION.styles
    })
  }
}

/**
 * Event shop Click in Market
 * @param obj
 * @param isResetShopList
 */
function shopOnClick (obj, isResetShopList = true) {
  try {
    balloon.close()
  } catch (e) {
  }

  let templateMapBalloon
  const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
  const template = _.template($('[data-js="search-list__balloon_template"]').html())

  // Trigger template for error padding on IOS
  const templateTrigger = template(this.data).replace('<div class="search-list__balloon__content">', '<div class="search-list__balloon__content" style="padding-right: 16px">')

  if ($(window).width() < 767) {
    templateMapBalloon = iOS ? templateTrigger : template(this.data)
  } else {
    templateMapBalloon = template(this.data)
  }

  if (typeof obj.latLng === 'undefined') {
    obj.latLng = new google.maps.LatLng(parseFloat(this.data.latitude), parseFloat(this.data.longitude))
  }

  $shopMap.panTo(obj.latLng)
  balloon = new google.maps.InfoWindow({
    position: obj.latLng,
    content: templateMapBalloon,
    pixelOffset: new google.maps.Size(0, -38)
  })

  balloon.open($shopMap)
  balloon.isResetShopList = isResetShopList

  if ('Ts' in window) {
    window.Ts.loadFont()
  }

  balloon.addListener("closeclick", () => {
    resetShopList()
    $('[data-js="search-list__shops__item"]').removeClass('active')
  })

  if (isResetShopList) {
    $('[data-js="search-list__shops__item"]').removeClass('active')
    setShopList(findAndMoveFirstShop(this.data), false)
    setTimeout(() => {
      $('.p-stores-search-map__sidebar__item-' + this.data.shop_code).addClass('active')
    }, 50)
  }
}

function resetShopList () {
  if (balloon.isResetShopList && $shopMap.getZoom() !== 20) {
    setShopList(currentShopList)
  }
}

function findAndMoveFirstShop (itemToFind) {
  let newShopList = currentShopList.filter(() => true)

  const foundElement = newShopList.find(el => el.data === itemToFind)
  const foundElementIndex = newShopList.findIndex(el => el.data === itemToFind)
  newShopList.splice(foundElementIndex, 1)
  newShopList.unshift(foundElement)

  return newShopList
}
